export const TRANSLATIONS_EN = {
    name: "Raybod  App",
    subscriber: "Subscribed by",
    userName: "Username",
    password: "Password",
    enterUserName: "Please  enter your username",
    userNameLength: "Username must be more than 5 characters long",
    enterPassword: "Please enter your password",
    passwordLength: "Password must be more than 6 characters long",
    login: "Login",
    designed: " Designed and Developed by Raybod Ravesh Co.",
    myProject: "My Projects",
    otherProject: "Others",
    newProject: " New Project",
    signOut: "Sign out",
    changePass: "Change Password",
    currentPass: "Current Password",
    newPass: "New Password",
    passRepeat: " Confirm New Password",
    register: "Register",
    onRegister: "Registering ...",
    cancel: " Cancel",
    enterCurrentPass: "Please enter current password",
    enterNewPass: "Please enter new password",
    confirmPass: "The Password you entered does not match! Please re-enter your password.",
    projectCode: "Project Code",
    projectDescription: "Project Description",
    fileDrive: "File Drive",
    documentManagement: "Document Management",
    procurementManagement: "Procurement Management",
    operationManagement: "Operation Management",
    projectMenu: "Project",
    aboutProject: "About Project",
    projectTeam: "Project Team",
    dashboard: "Dashboard",
    bi: "Business Intelligence",
    help: "Help",
    public: "Public",
    private: "Private",
    shared: "Shared",
    deleted: "Deleted",
    documentList: "Document List",
    documentPreparation: "Document Preparation",
    transmittal: "Transmittal",
    comment: "Comment",
    tq: "TQ",
    ncr: "NCR",
    projectList: "Project List",
    edit: "Edit",
    save: "Save",
    timeTable: "Project Timetable",
    startDate: "Start Date",
    endDate: "End Date",
    effectiveDate: "Effective Date",
    duration: "Duration",
    timetableUndefined: "Timetable is not Defined!",
    day: "Days",
    startDatebeforeEndDate: " The start date should be before end date!",
    startDatebeforeEffectiveDate: " The start date should be before effective date!",
    endDateAfterStartDate: " The end date should be after  start date!",
    endDateAfterEffectiveDate: " The end date should be after effective date!",
    effectiveDateAfterStartDate: " The effective date should be after  start date!",
    effectiveDateBeforeEndDate: " The effective date should be before end date!",
    client: "Client",
    clientCode: "Client Code",
    tel: "Tel",
    address: "Address",
    clientUndefined: "Client has not been selected!",
    clientRemove: " Remove Client",
    consultant: "Consultant",
    consultantCode: "Consultant Code",
    consultantUndefined: "Consultant has not been selected!",
    consultantRemove: " Remove Consultant",
    attachments: "Attachments",
    uploadFiles: "Upload Files",
    noFiles: "No file has been uploaded!",
    coding: "Coding",
    documentRev: "Document Revision",
    mrp: "Material  Planning",
    pr: "Purchase Request",
    rfp: " Request For Proposal",
    prc: " Purchase Contract",
    po: "Purchase Order",
    pk: "Packing",
    receipt: "Receipt",
    wr: "Dispatch Request",
    dispatch: "Dispatch",
    invoice: "Invoice",
    paymentRequest: "Payment Request",
    payment: "Payment",
    codingType: "Coding Type",
    numberType: "Number",
    alphabetType: "Alphabet",
    fixedChar: "Fixed Character",
    counterFormat: "Counter Format",
    codingSample: "Coding Sample",
    users: "Users",
    clientUsers: "Clinet / Consultant ",
    newUser: "New User",
    exportExcel: "Export Excel",
    search: "Search....",
    advancedSearch: "Advanced Search",
    user: "User",
    email: "Email",
    mobile: "Mobile",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    companyName: "Company Name",
    roleList: "Role asignments for",
    section: "Section",
    acl: "Access List",
    view: "View",
    manage: "Manage",
    archive: "Archive",
    unlimitedView: "Unlimited View",
    conditionalView: "Conditional View",
    fullView: "Full View",
    activityUpdate: "Activity Update",
    createRevision: "Create Revision",
    confirm: "Confirm",
    unlimitedConfirm: "Unlimited Confirm",
    reply: "Reply",
    equipmentList: "Equipment List",
    equipment: "Equipment ",
    preInvoiceRegister: "Pre-invoice Register",
    techProposal: "Technical Proposal",
    commercialProposal: "Commercial Proposal",
    proposalSelection: "Proposal Selection",
    logistics: "Logistics",
    poActivity: "Purchase Order Activity",
    poFinancial: "Purchase Order Financial",
    poInspection: "Production Inspection",
    supplierDocument: "Supplier Document",
    inventory: "Inventory",
    supplierAccount: "Supplier Account",
    packingManage: "Packing Manage",
    packingInspection: "Packing Inspection",
    transferManagement: "Transfer Manage",
    update: "Update",
    qc: "Quality Control",
    techEval: "Technical Evaluation",
    CommercialEval: "Commercial Evaluation",
    operationList: "Operation List",
    operationExecution: "Operation Execution",
    groupCode: "Group Code",
    groupTitle: " Group Title",
    selectedGroup: " Selected Groups",
    add: "Add",
    added: "Selected",
    documentGroupLimitation: "Document group limitation for ",
    productGroupLimitation: "Product group limitation for ",
    operationGroupLimitation: "Operation group limitation for ",
    addUser: " Add User",
    userFirstName: "First Name",
    userLastName: "Last Name",
    selectedUsers: "Selected Users",

    documentInprogress: "In Progress Documents",
    pendingConfirmationDocuments: "Pending Confirmation Documents",
    pendingTransmittalDocuments: "Pending Transmittal Documents",
    replyPendingComments: "Pending Reply  Commnets ",
    replyPendingTq: " Pending Reply TQ ",
    replyPendingNcr: " Pending Reply NCR ",


    pendingConfirmationPurchaseRequests: "Pending Confirmation Purchase Requests ",
    pendingRegisterRfps: "Pending Registering RFPs",
    inProgressRfps: "In Progress RFPs ",
    PendingRegisterPurchaseOrders: "Pending Registering Purchase Orders ",
    inProgressPurchaseOrders: "In Progress Purchase Orders ",
    inProgressOperations: "In Progress Operations ",


    title: "Title",
    code: "Code",
    group: "Group",
    class: "Class",
    creator: "Creator",
    dueDate: "Due Date",
    revision: "Rev.",
    pendingModification: "Rejected",
    reason: "Reason",
    documents: "Documents",
    document: "Document",
    folderEmpty: "No Files Added!",
    accessLimited: "Access Denied",
    accessLimitedDes: "You don't have permission to access this page",
    callAdmin: "Please contant administrator!",
    remove: "Remove",
    documentsPendingRegister: "Pending for document Registering",
    newDocuments: "New Documents",
    area: "Area",
    lastRevision: "Last Revision",
    status: "Status",
    inProgress: "In Progress",
    pendingConfirmation: "Pending Confirmation",
    confirmed: "Confirmed",
    TransmittalIfa: "Transmittal-IFA",
    TransmittalIfi: "Transmittal-IFI",
    TransmittalIfc: "Transmittal-IFC",
    TransmittalIfr: "Transmittal-IFR",
    TransmittalIff: "Transmittal-IFF",
    TransmittalAsb: "Transmittal-ASB",
    filter: "Filter",
    filtering: "Filtering ...",
    transmittalRequired: "Transmittal Required",
    rejected: "Rejected",
    nothing: "Nothing",
    all: "All",
    importExcel: "Import From Excel",
    excelFormat: "Excel Fromat",
    clientNumber: "Client No.",
    linkedItems: "Linked Items",
    remark: "Remark",
    yes: "Yes",
    no: "No",
    history: "History",
    documentRevisions: " Document Revision List",
    number: "Number",
    date: "Date",
    confirmationWorkflow: "Confirmation Workflow",
    communication: "Communication",
    receiverCompany: "Receiver Company",
    receiverPerson: "Receiver Person",
    type: "Type",
    close: "Close",
    registered: "Registered",
    edited: "Edited",
    activated: "Activated",
    inactivated: "Inactivated",
    preparedBy: " Prepared by",
    otherPersons: " Other persons",
    and: " and",
    onDate: "on",
    confirmedBy: "Confirmed by",
    persons: "Persons",
    filesUploaded: "Files Uploaded",
    transmittedOn: "Transmitted On",
    newRevision: "New Revision",
    onlyRejected: " Only Rejected",
    lastRevision: "Last Revision",
    finalizing: "Finalizing",
    deActivate: "Deactivate",
    finalizingHistory: "Finalizing History",
    files: "Files",
    activities: "Activities",
    commentAndReply: "Comment and Reply",
    newActivity: "New Activity",
    responsible: "Responsible",
    registeredWorkingTime: "Registered Working Time",
    workingTime: "Working Time",
    newComment: "New Comment",
    typeYourComment: "Type your comment here...",
    send: "Send",
    sending: "Sending",
    attachment: "attachment",
    copy: "Copy",
    typeYourReply: "Type your reply here...",
    aMomentAgo: "a moment ago",
    dragFiles: "Drag and Drop Files Here ...",
    specifications: "Specifications",
    paperSize: "Paper Size",
    pageNumbers: "Page Numbers",
    description: "Description",
    selectFileFromRevisionDetail: " Select files from revision details",
    addConfirmer: "Add Confirmer",
    selectConfirmer: "Select Confirmer",
    finalizingWithoutWf: "Continue without confirmation workflow?",
    select: "Select",
    selectFile: "Select File",
    deactivateRevisionWarning: "Do you want to deactivate the document? ",
    revisionDeactivated: "The Document Has Been Deactvicated!",
    revisionPendingConfirmation: "The Documant Is Pending For Confirmation!",
    revisionConfirmed: "The Document Has Been Confirmed!",
    revisionTransmitted: "The Document Has Been Transmitted",
    sentBy: "Sent by",
    revisionConfirmation: "Revision Confirmation",
    reject: "Reject",
    otherWf: "Other Workflows",
    result: "Result",
    rejectReason: "Please type the reason of rejection",
    transmittalList: "Transmittal List",
    pendingTransmittal: "Pending Transmittal",
    newTransmittal: "New Transmittal",
    filtering: "filtering...",
    sender: "Sender",
    receiver: "Receiver",
    cc: "CC",
    content: "Content",
    subject: "Subject",
    selectedDocuments: "Selected Documents",
    cancelWarning: "Do you want to cancel?",
    commentList: "Comment List",
    commentOrDocument: "Comment / Document",
    Issuer: "Issuer",
    pendingReply: "Pending Reply",
    replyed: "Replied",
    closed: "Closed",
    replyRegistrant: "Reply Registrant",
    commentStatus: "Comment Status",
    commentRegistrant: "Comment Registrant",
    details: "Details",
    comments: "Comments",
    replyRegistration: "Reply Registration",
    commentsReplyed: "Comment has been replied",
    commentClosed: "Comment has been closed",
    TypeComment: "Type your comment and then press enter...",
    newTq: "New TQ",
    tqList: "TQ List",
    tqRegistrant: "TQ Registrant",
    replyRegistrant: "Reply Registrant",
    TqOrDocument: "TQ  / Document",
    tqReplyed: "TQ Replied!",
    tqClosed: "TQ Closed!",
    newNcr: "New NCR",
    ncrList: "NCR List",
    ncrRegistrant: "NCR Registrant",
    ncrOrDocument: "NCR  / Document",
    ncrReplyed: "NCR Replied!",
    ncrClosed: "NCR Closed!",
    design: "Design",
    supplier: "Supplier",
    contractor: "Contractor",
    noProjectTeamFound: " You have not been added to any project team",
    ok: "Ok",
    permanentDelete: "Permanent Delete",
    permanentDeleteWarning: " If you continue file or folder will be deleted prmanently! ",
    allItem: "All Items",
    activate: "Activate",
    documentDeactivateWarning: "Creating revision for deactivated document is not allowed!",
    download: "Download",
    newCommentSheet: "New Comment",

    commented: "Commented",
    approved: "Approved",
    commentAfc: " Commented - AFC ",
    approvedAsNoted: "Approved As Noted",
    commentRejected: "Rejected",
    userRemove: "Are you sure you want to remove the user?",
    deleteFile: "Deleting File",
    deleteFileWarning: "Are you sure you want to remove the file?",
    globalReply: "Unlimited Reply",
    editDocument: "Edit Document ",
    notifSetting: "Notification Setting",
    profile: "Profile",
    reminder: "Reminder",
    event: "Event",
    forgotPassword: "Forgot Password?",
    sendRecoveryLink: "Send Password Recovery Link",
    backToLogin: "Back To Login",
    passwordRecoveryFor: "Password Recovery For",
    recoveryExpired: " Password Recovery Link is Expired!",
    recoveryLinkSent: "Recovery Link Sent To Your Email!",
    latestDocumentsStatusList: "Latest Documents Status List",
    latestRevisionsStatusList: "Latest Revisions Status List",
    revisionsHistoryList: "Revisions History List",
    internal: "Internal",
    transmittalType: "Transmittal Type",
    documentGroup: "Document Group",
    generalComment: " General Comment",
    commentSheet: "Comment Sheet",
    commentAttachment: "Comment Attachment",
    replyAttachment: "Reply Attachment",
    warehouse: "Warehouse",
    financial: "Financial",
    comprehensiveList: "Comprehensive List",
    treeList: "Tree List",
    newEquipment: "New Equipment",
    unplanned: "Unplanned",
    planned: "Planned",
    rfpInProgress: "RFP in Progress",
    rfpEvaluated: "RFP Evaluated",
    supplierSelection: "Supplier Selection",
    poInProgress: "Purchase Order in Progress",
    delivered: "Delivered",
    newEquipmentList: "New Equipment List",
    selectFromEqList: "Select From Equipment List",
    informationIssue: "Information Issue",
    informationIssueDes: " Please ensure following fields are filled:  code, title, unit and quantity ",
    groupIssue: "Please select a group",
    technicalCode: "Technical Code",
    set: "Set",
    requiredQuantity: "Required Quantity",
    planningRequired: "Planning Required",
    no: "No",
    yes: "Yes",
    importExcelError: "Input data is not valid, Please use the sample excel format",
    pendingForComponent: "Pending For Component",
    unit: "Unit",
    completed: "Completed",
    part: "Part",
    component: "Component",
    quantity: "Quantity",
    reqirementList: "Requirement List",
    reference: "Reference",
    remained: "Remained",
    grossRequirement: "Gross Requirement",
    finalRequirement: "Final Requirement",
    start: "Start",
    finish: "Finish",
    canceled: "Canceled",
    techprop: "Technical Proposal",
    commerceProp: "Commercial Proposal",
    proposalEvaluation: "Proposal Evaluation",
    proposalSelection: "Proposal Selection",
    setting: "Setting",
    usersDes: "Cilck here for adding, editing or removing users!",
    teams: "Teams",
    producGroup: "Product Group",
    operationGroup: "Operation Group",
    clients: "Clients",
    consultants: "Consultants",
    suppliers: "Suppliers",
    totalUsers: "Total Users",
    ForUsers: "Name",
    userAccess: "User Access",
    submit: "Submit",
    upload: "Upload",
    firstnameIsrequired: " First name is Required!",
    lastnameIsrequired: " Last name is Required!",
    emailIsRequied: "Email is required",
    emailValidation: "Email is not valid",
    firstnameLength: " First name must be between 2 and 50 characters long!",
    lastnameLength: " Last name must be between 2 and 50 characters long!",
    mobileLength: " Mobile maximum length is 13 characters!",
    mobileValidation: " Mobile is not valid!",
    userEdit: "User Edit",
    userActivated: "User Activated",
    userInactivated: "User Inactivated",
    userRemove: "Are you sure to remove the user?",
    organizational: "Organizational",
    totalGroups: "Total Groups",
    addGroup: "Add Group",
    clickHereToAddNew: " Click Here To Add New",
    groupRemove: "Are you sure you want to remove the group?",
    editGroup: "Editing Group",
    totalClients: "Total Clients",
    addClient: "Add Client",

    fax: "Fax",
    postalCode: "Postal Code",
    website: "Website",

    companyNameIsrequired: " Company name is Required!",
    companyNameLength: " Company name must be between 2 and 50 characters long!",

    companyCodeIsrequired: " Company code is Required!",
    companyCodeLength: " Company code must be between 1 and 5 characters long!",

    editClient: "Editing Client",
    removeClient: "Are you sure want to remove the client?",
    loginPermission: "Login Permission",
    createUserAccount: "This option creates an account for the user and login information will be emailed to user 's email address!",



    totalConsultants: "Total Consultants",
    addConsultant: "Add Consultant",
    editConsultant: "Editing Consultant",
    removeConsultant: "Are you sure want to remove the consultant?",
    editConsultant: "Editing Consultant",



    totalSuppliers: "Total Suppliers",
    addSupplier: "Add Supplier",
    editSupplier: "Editing Supplier",
    removeSupplier: "Are you sure want to remove the supplier?",
    editSupplier: "Editing Supplier",
    economicCode: "Economic Code",
    nationalCode: "National Code",
    productGroup: "Product Group",

    appNewVersion: " New Version",
    appVersionNo: "Version Number",
    appNewVersionDes: " has been released. Plese click the button to update your current version. It may takes few minutes and you can read the latest changes!",
    appUpdate: "Update",


    clientPanel: "Client / Consultant Panel",
    all: "All",
    pendingComment: "Pending Comment",
    pendingMrp: "Pending Planning",
    mrpList: ' Planning List',
    informationIssueDesDocument: " Please ensure following fields are filled:  group,code, title and class  ",
    reservedInventory: "Reserved Inventory",
    netRequirement: "Net Requirement",
    surplusQuantity: " Surplus Quantity",
    pendingRegistration: "Pending Registration",
    prList: "Purchase Request List",
    itemNumber: "Items",
    selectAll: "Select All",
    removeAll: "Remove All",
    selectedList: "Selected List",
    operationSucceded: " Operation Succeded",
    prConfirmation: "Purchase Order Confirmation",
    rfpList: "RFP List",
    rfpType: "RFP Type",
    proposal: "Proposal",
    preInvoice: "Pre Invoice",
    techInquiry: "Technical Inquiry",
    commercialInquiry: "Commercial Inquiry",
    weight: "Weight",
    whatsYourTechProposal: " Whats is your Technical proposal",
    price: "Price",
    deliveryTime: "Delivery Time",
    emptyInquiry: "Inquiry Description Must be filled",
    supplierEdit: "Edit Suppliers",
    commercialInqueryEdit: " Edit Commercial Inquiry",
    techIqueryEdit: "Edit Technical Inquiry",
    winnerSelection: "Winner Selection",
    cancelRfp: " Cancel RFP",
    rfPIsCanceled: "RFP Is Canceled",
    downloadAll: "Download All",
    changeDesNotAllowed: " Changing description is not allowed!",
    changeInqNotAllowed: " Removing inquiry is not allowed!",
    totalEvaluationScore: "Total Evaluation Score",
    supplierAnswer: "Supplier Answer",
    evaluationScore: "Evaluation Score",
    evaluation: "Evaluation",
    proposalRegister: "Proposal Register",
    inquiryList: "Inquiry List",
    reEvaluation: "Re Evaluation",
    isEvaluated: "This proposal has evaluated!",
    evaluationNotAllowed: "Changing evaluation or proposal is not allowed as winner is selected",
    fianlScore: "Final Score",
    priceEmpty: "Please enter price",
    winnerProposalSelection: "Winner Proposal Selection",
    techProposalScore: "Technical Proposal Score",
    commercialProposalScore: "Commercial Proposal Score",
    continue: "Continue",
    cancelRfpWarning: "Are sure about canceling RFP?",
    prcList: "Purchase Contract List",
    newContract: "New Contract",
    rial: "Rial",
    euro: "Euro",
    dollar: "Dollar",
    supplierWarehouse: "Supplier 's Warehouse",
    customsOfOrigin: "Customs Of Origin",
    destinationCustoms: "Destination Customs",
    purchaserWarehouse: "Purchaser's Warehouse",
    local: "Local",
    overseas: "Overseas",
    cancelPrcWarning: "Are sure about canceling the purchase contract?",
    contractInformation: "Contract Information",
    supplierInformation: "Supplier Information",
    fistSelectSupplier: "Please select Supplier",
    contractTimeTable: "Contract Time Table",
    contractDuration: "Contract Duration",
    cancelContract: "Cancel Contract",
    contractCondition: "Contract Condition",
    contractType: "Contract Type",
    deliveryLocation: "Delivery Location",
    currency: "Currency",
    vat: "VAT",
    contractSubject: "Contract Subject",
    unitPrice: "Unit Price",
    totalPrice: "Total Price",
    totalAmount: "Total Amount",
    finalAmount: "Final Amount",
    paymentTerms: "Payment Terms",
    percent: "Percent",
    daysCredit: "Days Credit",
    paymentOnPoConfirmation: " Payment on purchase order confirmation",
    paymentOnPoPreparation: "Payment on Purchase Order Preparation",
    paymentOnPoPacking: "Payment on purchase order Packing",
    paymentOnInvoice: "Payment on invoice issuing",
    refinalizing: "Re-Finalizing",
    paymentPercentMax: " Payment percent must be equal or less than 100%",
    totalPaymentPercentMax: "Total payment percent must be equal or less than 100%",
    poReport: "Purchase order Report",
    fiReport: "Financial Report",
    paid: "Paid",
    preparation: "Preparation",
    poConfirmation: "Purchase Order Confirmation",
    overDue: "Over Due",
    notOverDue: "Not Over Due",
    paymentTermsUndefined: "Payment terms is not defined",
    subjectUndefiend: "Subject is not defined",
    conditionUndefined: "Condition is not defined",
    poList: "Purchase Order List",
    poDeliveryTime: "Order Delivery Time",
    progressPercent: "Progress Percent",
    supplierDocuments: "Supplier Documents",
    inlineInspection: "in-line Inspection",
    cancelPo: "  Cancel Order",
    cancelPoWarning: "Are sure about canceling Order?",
    poIsCanceled: "Order is canceled",
    progress: "Progress",
    progressValidation: "Progress percent must be greater than 0",
    packingCancelWarning: "Are you sure about removing packing?",
    pendingQC: " Pending QC",
    purchaseRejection: "Purchase Rejection",
    conditionalAccepatnce: "Conditional Acceptance",
    qcPass: "QC Pass",
    newPacking: "New Packing",
    inspectedBy: "Inspected by",
    pendingInspection: "Pending Inspection",
    inTransitToCustomOfOrigin: "In transit to custom of origin",
    waitingForClearanceFromCustomOfOrigin: "Waiting for clearance from custom of origin",
    clearanceInProgressInCustomOfOrigin: "Clearance in progress in custom of origin",
    waitingForTransitToCustomOfDestination: "Waiting for transit to custom of destination",
    inTransitToCustomOfDestination: "In transit to custom of destination",
    waitingForClearanceFromCustomOfDestination: "Waiting for clearance from custom of destination",
    clearanceInProgressInCustomOfDestination: "Clearance in progress in custom of destination",
    waitingForTransitToBuyersWarehouse: "Waiting for transit to buyer's warehouse",
    inTransitToBuyersWarehouse: "In transit to buyer's warehouse",
    deliveredToBuyersWarehouse: "Delivered to buyer's warehouse",
    WarehouseReceipt: "Warehouse receipt",
    newInspection: "New Inspection",
    transportation: "Transportation",
    packingValidation: "Quantity must be less than remained!",
    inspection: "Inspection",
    transitToOrigin: "Transit to custom of origin",
    clearanceFromOrigin: "Clearance from custom of origin",
    transitToDestination: "Transit to custome of destination",
    clearanceFromDestination: "Clearance from custom of destination",
    transitToWarehose: "Transit to buyer 's warehose",
    paymentAmount: "Payment Amount",
    poInvoices: "Purchase order invoices",
    paymentRequestValidation: " Payment request amount must be less than payable amount",
    newPaymentRequest: "New Payment Request",
    payableAmount: "Payable Amount",
    requestAmount: "Reaquest Amount",
    other: "Other",
    removePaymentRequestWarning: "Are you sure about removing payment request?",
    removeDocumentWarning: "Are you sure about removing document? ",
    removeInspectionWarning: "Are you sure about removing inspection? ",
    pendingInspecttion: "Pending Inspection",
    inspectionRequest: "Inspection Request",
    inspector: "Inspector",
    productRequest: "Product Request",
    warehouseInput: "Warehouse Input",
    warehouseOutput: "  Warehouse Output",
    warehouseInventory: "Warehouse Inventory",
    requestList: "Request List",
    newRequest: "New Request",
    selectEquipment: "Please select equipment",
    receiptList: "Receipt List",
    receiptValidation: " Receipt quantity must be less than packing quantity!",
    qcValidation: " Accepted quantity must be less than receipt quantity!",
    transferoutList: "Transfer Out List",
    transferoutValidation1: " delivery quantity must be less than inventory quantity!",
    transferoutValidation2: " delivery quantity must be less than request quantity!",
    cancelDelivery: "Cancel Delivery",
    compeletedDelivery: "completed Delivery",
    partialDelivery: "Partial Delivery",
    lastChanges: " Last Changes",
    kardex: "Kardex",
    financialStatement: "Financial Statement",
    pendingPayment: "Pending Payment",
    paymentList: "Payment List",
    paymentCancelWarning: " If you continue, payment will be canceled prmanently! ",
    payedAmount: "    Payed amount",
    cancelPayment: "Cancel",
    paymentValidation: "Payment qunatity must be filled",
    paymentValidation2: "Payment qunatity must be less than remained",
    invoiceList: "Invoice List",
    rejectionInvoice: "Purchase rejection invoice",
    accountType: "Account Type",
    purchaseInvoice: "Purchase Invoice",
    accountList: "Account List",
    newOperation: "New Operation",
    notStarted: "Not started",
    startOperation: " Start Operation",
    operationDeactiveWarning: "If you deactivate the operation, you can not update it!",
    dueDateWarning: "Please specify due date!",
    operation: "Operation",
    operationFinalizingWarning: " After finalizing, operation status will be changed to completed!",
    cancelOperationWarning: "After canceling, operation status will be changed to not started",
    cancelOperation: "Cancel Operation",
    cancelFinalizingOperationWarning: "After canceling, operation status will be changed to in progress",
    cancelFinalizing: "Cancel Finalizing",
    operationFinalized: "Operation is finalized!",
    operationIsCanceled: "Operation is canceled!",
    commentsheetCode: "Comment Code",
    getNewCommentsheetCode: "click the button to get a valid code ",
    click: "Click",
    revisionFileEdit: "Revision File edit",
    fileType: "File Type",
    fileSize: "File Size",
    newFiles: "New Files",
    currentFiles: "Current Files",
    editTr: "Edit Transmittal",
    lastConfirmedRevision: "Last Confirmed Revision",
    prQuantityValidation: "Request quantity must be equal or lower than required quantity!",
    contractAmendment: "Contract Amendment",
    commentsheetEdit: "Commentsheet Edit",
    amendment: "Amendment",
    selectedEquipment: "Selected Equipment",
    approvedForConstruction: "Approved For Construction",
    requirement: "Requirement",
    removeEqWarning: "Are sure about removing the equipment?",
    removeDocWarning: "Are sure about removing the Document?",
    nonconformity: " Nonconformity",
    nonconformityList: "Nonconformity List",
    pendingAction: "Pending Action",
    newNonconformity: "New Nonconformity",
    process: "Process",
    pendingForAction: "Pending For Action",
    correctiveActions: "Corrective and Preventive Actions",
    consequence: "Consequence",
    source: "source",
    preventive: "Preventive",
    corrective: "Corrective",
    cancelNcWarning: "Are you sure about canceling nonconformity?",
    ncCancel: "Cancel Nonconformity",
    pendingPr: "Pending Purchase Request",
    totalCompanies: "Total Companies",
    newCompany: "New Company",
    companyDetails: "Company Details",
    removeProject: "Remove Project",
    removeProjectWarning: "Are sure about removing this project?",
    informationIssueOpDes: " Please ensure following fields are filled:  code and title ",
    delivery: "Delivery",
    hse: "HSE",
    anomalyList: "Anomaly List",
    anomalyActions: "Anomaly Actions",
    newAnomaly: "New Anomaly",
    company: "Company",
    workshop: "Workshop",
    location: "Location",
    root: "Root",
    impact: "Impact",
    category: "Category",
    immediateActions: "Immediate Actions",
    rootCause: "Root Cause",
    pendingActionConfirmation: "Pending Action Confirmation",
    anomalyActionList: "Anomaly Action List",
    cancelAnomaly: " Cancel Anomaly",
    transmittaldocument: "Transmittal / Document",
    anomaly: "Anomaly",
    trdocuments: "Documents",
    cancelAnomalyWarning: "Are you sure about canceling anomaly?",
    moduleSelection: "Select Modules",
    manufacturingManagement: "Manufacturing Management",
    partManagement: "Part Management",
    assemblyManagement: "Assembly Management",
    basicInformation: "Basic Information",
    workForce: "Workforce",
    workStage: "Work Stage",
    workPackage: "Work Package",
    workforceName: " Workforce Name",
    personalCode: "Personal Code",
    jobTitle: "Job Title",
    newWorkforce: "New Workforce",
    image: "Image",
    informationIssueWfDes: " Please ensure all fields are filled ",
    newWorkStage: "New Work Stage",
    removeWorkStageWarning: "Are you sure about removing the work stage?",
    partType: "Part",
    assemblyType: "Assmebly",
    newWorkPackage: "New Work Package",
    workStages: "Work Stages",
    workStageSelection: "Work Stage Selection",
    removeWorkPackageWarning: "Are you sure about removing the work package?",
    partList: "Part List",
    manufacturingPlan: "Manufacturing Plan",
    manufacturingReport: "Manufacturing Report",
    phase: "Phase",
    specification: "Specification",
    length: "Length",
    area1: "Area",
    newPart: "New Part",
    materialType: "Material Type",
    removePartWarning: "Are you sure about removing the part?",
    numbers: "Number",
    workPackageSelection: "Work Package Selection",
    AddManufacturingReport: "Add Manufacturing Report",
    partSelection: "Part Selection",
    assemblyList: "Assembly List",
    assemblyPlan: "Assembly Plan",
    assemblyReport: "Assembly Report",
    newAssembly: "New Assembly",
    coefficient: "coefficient",
    total: "Total",
    removeAssemblyWarning: "Are you sure about removing the assembly?",
    partSelection: "Assembly Selection",
    partManufacturingReport: " Part Manufacturing Report",
    assemblyManufacturingReport: " Assembly Manufacturing Report",
    formName: "Form Name",
    cancelWinnerSelection: "Cancel Winner Selection",
    wfinformationIssueOpDes: "Please fill out all neccessary fields!",
    sendInvitation: " Send invitation",
    publicConversation: "Public Conversation",
    addConversation: "Add Conversation",
    projectNews: "Project News",
    projectReminders: "Project Reminders",
    projectNewsLastMessage: "Lastest Events of The Project",
    projectRemindersLastMessage: "Active Reminders",
    eventNo: "Event No.",
    service: "Service",
    markAsCompleted: "Mark As Completed",
    markAsIncomplete: "Mark As Incomplete",
    members: "Members",
    follow: "Follow",
    viewAllReplies: "View All Replies",
    follower: "Follower",
    followed: "Followed",
    moreReplies: "more replies",
    planning: "Planning",
    timeManagement: "Time Management",
    budgetManagement: "Budget Management",
    resourceManagement: "Resource Management",
    schedulingList: "Scheduling List",
    planStart: "Plan Start",
    planFinish: "Plan Finish",
    planDuration: "Plan Duration",
    planProgress: "PlanProgress",
    floating: "Floating",
    actualStart: "Actual Start",
    actualFinish: "Actual Finish",
    actualDuration: "Actual Duration",
    actualProgress: "ActualProgress",
    delay: "Delay",
    planRegistration: "Plan Registration",
    codeOrTitle: "Code or Title",
    unscheduled: "Unscheduled",
    planInProgress: "0 < Plan Progress < 100",
    planCompleted: " Plan Progress = 100",
    actualInProgress: "0 < Actual Progress < 100",
    actualCompleted: " Actual Progress = 100",
    progressProcedure: "Progress Procedure",
    faDocumentProcedurs: "Document Management - FA Class",
    fiDocumentProcedurs: "Document Management - FI Class",
    internalProductProcedurs: "Procurement Management - Local Purchasing",
    externalProductProcedurs: "Procurement Management - Overseas Purchasing",
    totalPercentage: "Total Percentage",
    step: "Step",
    progressPercent: "Progress Percent",

    createRevisionStep: "Revesion Creation",
    finalizatingStep: "Revision Finalizing",
    confirmedStep: "Revision Confirmation",
    transimittalStep: "Transmittal",
    TransmittalIfcStep: "Transmittal - IFC",
    commentStep: "Comment Registration",
    replyedStep: "Comment Replying",
    closedStep: "Comment Closed",
    commentAfcStep: "Comment Registration - AFC",
    prStep: "Purchase Request Registration",
    PurchaseRequestConfirmStep: "Purchase Request Confirmation",
    RFPStep: "RFP Registration",
    TechnicalProposalStep: "Technical Proposal Registration",
    CommercialProposalStep: "Commercial Proposal Registration",
    TBEStep: "Technical Proposal Evaluation",
    CBEStep: "Commercial Proposal Evaluation",
    VendorSelectionStep: "Vendor Selection",
    ContractConfirmedStep: "Purchasing Contract Confirmation",
    POStep: "Purchase Order Registration",
    PackingStep: "Packing",
    FinalInspectionStep: "Final Inscpection",
    StartTansportationStep: "Transporation Started",
    FinishTansportationStep: "Transportation Finished",
    ReceiptStep: "Receipt Registration",
    budgtingList: "Budgeting List",
    cost: "Cost",
    income: "Income",
    cashFlow: "CashFlow",
    forecast: "Forecast",
    earnedValue: "Earned Value",
    actual: "Actual",
    variance: "Variance",
    activity: "Activity",
    in: "In",
    out: "Out",
    ResouceList: "Resource List",
    externalProcurement: "Overseas Procurement",
    estimatedWork: "Estimated Work",
    performedWork: "Performed Work  ",
    userList: "User List",
    clientUser: "Client User",
    consultantUser: "Consultant User",
    noComment: "No Comment",
    observed: "Observed",
    updateBudgetWithExcel: "Update Budget with Excel",
    submitPlanWithExcel: "Submit Plan with Excel",
    recordProcessed: "Record processed and ready for registration!",
    revisionConfirmationEdit: "Confiramtion workflow edit",
    removeLastWorkFlow: "Delete workflow",
    editLastWorkFlow: "Edit workflow",
    choseWorkflowEditType: "Select Workflow Operation",
    sysAdmin: "System Admin",
    admin: "Admin"
























































};